module.exports = __webpack_public_path__ + "static/branching-f6ac2e83193c96e0ae1f864723d3456c.jpg";